import styled from 'styled-components';

import { Text } from '../../../../components';
import { COLORS, SPACE } from '../../../../theme/tokens';

export const Root = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[20]};
  min-width: 0;
`;

export const Head = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${SPACE[12]} ${SPACE[16]};
  flex-wrap: wrap;
`;

export const HeadText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
  min-width: 0;
`;

export const TitleLine = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  flex-wrap: wrap;
`;

export const Title = styled(Text)`
  font-size: 18px;
  font-weight: 700;
  color: ${COLORS.textStrong};
`;

export const KindChip = styled(Text)`
  padding: ${SPACE[2]} ${SPACE[8]};
  border-radius: 999px;
  border: 1px solid ${COLORS.panelBorder};
  font-size: 11px;
  font-weight: 600;
  color: ${COLORS.textMuted};
`;

export const Path = styled(Text)`
  font-size: 13px;
  color: ${COLORS.textMuted};
  word-break: break-all;
`;

export const Note = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const ErrorNote = styled(Text)`
  font-size: 12px;
  color: ${COLORS.danger};
`;

export const Panels = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

export const ConfirmText = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${SPACE[8]};
`;
